<template>
  <cube-popup type="extend-popup" ref="popup" class="animated slideInUp" position="top">
    <div class="content">
      <svg-icon v-if="close" icon-class="close" @click.native="hide"></svg-icon>
      <h1>欢迎使用鸿合账号登录</h1>

      <div class="form">
        <cube-input
          ref="mobile"
          class="m-input"
          v-model="mobile"
          placeholder="请输入手机号码"
          type="number"
          :autofocus="true"
          @blur="blurHandler"
        >
          <img class="icon" alt="账号" src="@/assets/loginName.png" slot="prepend" />
        </cube-input>
        <cube-input
          v-if="loginTypeCode"
          class="m-input"
          v-model="code"
          placeholder="请输入短信验证码"
          type="number"
          @blur="blurHandler"
        >
          <img class="icon" alt="验证码" src="@/assets/loginPassword.png" slot="prepend" />
          <span slot="append" @click="sendCode">{{ codeText }}</span>
        </cube-input>
        <cube-input
          v-else
          class="m-input"
          v-model="password"
          placeholder="请输入密码"
          type="password"
          @blur="blurHandler"
        >
          <img class="icon" alt="密码" src="@/assets/loginPassword.png" slot="prepend" />
        </cube-input>
        <p @click="changeType">{{ typeText }}</p>
        <cube-button :primary="true" @click="submitHandler">登 录</cube-button>
        <!--<p class="tips">提示：未注册的手机号，登录时将自动注册。</p>-->
        <p class="tips">
          没有账号怎么办？使用手机获取验证码登录并自动注册 <br />
          或下载 鸿合爱学班班APP 注册账号
        </p>
      </div>
    </div>
  </cube-popup>
</template>

<script>
import api from '@/api/app';
import schoolMixin from '@/mixins/school';

export default {
  name: 'm-cube-extend-popup',
  props: {
    // 用于判断是否需要获取资源平台的用户id
    isVideo: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowLogin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      validity: {},
      valid: undefined,
      mobile: '',
      code: '',
      password: '',
      loginTypeCode: true,
      count: 61,
      codeNum: 0,
      close: true,
      deviceUuid: ''
    };
  },
  computed: {
    typeText() {
      return this.loginTypeCode ? '使用密码登录>>' : '使用验证码登录>>';
    },
    codeText() {
      return this.count === 61
        ? this.codeNum
          ? '重新发送'
          : '获取验证码'
        : `再次发送（${this.count}）`;
    }
  },
  mixins: [schoolMixin],
  methods: {
    show(value, deviceUuid = '') {
      console.log('======', value);
      // value 是否显示关闭按钮
      this.$refs.popup.show();
      this.close = value;
      this.deviceUuid = deviceUuid;
      this.$emit('changeShowLogin', true);
    },
    hide() {
      const element = document.querySelector('.slideInUp');
      element.classList.add('slideOutDown');
      setTimeout(() => {
        this.$refs.popup.hide();
        element.classList.remove('slideOutDown');
      }, 500);
      this.$emit('hide');
      this.$emit('changeShowLogin', false);
    },
    submitHandler() {
      if (this.mobile.trim() === '') {
        this.$createToast({
          txt: '请输入手机号码',
          type: 'warn'
        }).show();
        return;
      }

      if (!this.$checkMobile(this.mobile)) {
        this.$createToast({
          txt: '请输入合法的手机号码',
          type: 'warn'
        }).show();
        return;
      }

      if (this.loginTypeCode && this.code === '') {
        this.$createToast({
          txt: '请输入短信验证码',
          type: 'warn'
        }).show();
        return;
      }

      if (!this.loginTypeCode && this.password.trim() === '') {
        this.$createToast({
          txt: '请输入密码',
          type: 'warn'
        }).show();
        return;
      }

      if (this.loginTypeCode) {
        this.codeLogin();
      } else {
        this.login();
      }
    },
    changeType() {
      this.password = '';
      this.code = '';
      this.loginTypeCode = !this.loginTypeCode;
    },
    sendCode() {
      console.log('this.timer-----', this.timer);
      if (this.timer) {
        return;
      }

      if (this.mobile.trim() === '') {
        this.$createToast({
          txt: '请输入手机号码',
          type: 'warn'
        }).show();
      } else if (this.$checkMobile(this.mobile)) {
        this.sendPhoneCode();
      } else {
        this.$createToast({
          txt: '请输入合法的手机号码',
          type: 'warn'
        }).show();
      }
    },
    // 60秒倒计时
    countDown() {
      if (this.count === 1) {
        this.clearInterval();
        this.count = 61;
        this.codeNum++;
      } else {
        this.count = this.count - 1;
      }
    },
    clearInterval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = '';
      }
    },
    sendPhoneCode() {
      api.sendPhoneCode({ mobile: this.mobile }).then(response => {
        // if (response.code === 0 && response.result.success === true) {
        if (response.result === true) {
          this.timer = setInterval(this.countDown, 1000);
          this.$createToast({
            txt: '验证码发送成功',
            type: 'correct'
          }).show();
        } else {
          this.$createToast({
            txt: '验证码发送失败',
            type: 'error'
          }).show();
        }
      });
    },
    login() {
      const params = {
        // username: this.mobile,
        userName: this.mobile,
        password: this.password
        // rememberMe: '1',
        // issign: true,
        // usertype: '1'
      };
      api.login(params).then(response => {
        console.log('response:登录接口： ', response);
        // if (response.code === 0 && response.result.success) { //php后端
        console.log(
          'response.result !== 2 && response.result !== 3: ',
          response.result !== 2 && response.result !== 3
        );
        if (response.result !== 2 && response.result !== 3) {
          console.log('登录接口：', response);
          let outTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
          // 获取用户信息，设置SET_USER_INFO
          api
            .fetchUserInfo({
              mobile: this.mobile
            })
            .then(response => {
              console.log('获取用户信息：', response);
              // if (response.result.success) { //php后端
              if (response.code === 0) {
                if (response.result.defaultSchoolName !== '') {
                  this.clearForm();
                  !this.isVideo && this.hide();
                  this.isVideo && this.getSchoolIp(response.result.defaultSchoolName, true);
                  window.localStorage['mobile'] = response.result.mobile; // localstorage
                  window.localStorage['outTime'] = outTime;
                  let userInfo = response.result;
                  api
                    .getUserSign({
                      userId: userInfo.uid
                    })
                    .then(resSig => {
                      console.log('res:getUserSign ', resSig);
                      userInfo = { ...userInfo, ...resSig.result };
                      global.localStorage.setItem('userInfo', JSON.stringify(userInfo));
                      // window.localStorage['loginInfo'] = JSON.stringify(loginInfo);
                      if (this.deviceUuid) {
                        // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
                        this.$store.commit('SET_USER_INFO', userInfo);
                        // 通过录播助手进入的列表页面，登录后刷新页面
                        location.reload();
                      } else {
                        this.$store.commit('SET_VISITOR_INFO', userInfo);
                        global.localStorage.setItem('visitorInfo', JSON.stringify(userInfo));
                        location.reload();
                      }
                    });
                } else {
                  this.$createToast({
                    txt: '请到鸿合云平台完善个人信息',
                    type: 'error'
                  }).show();
                }
              } else {
                this.$createToast({
                  txt: '登录失败',
                  type: 'error'
                }).show();
              }
            });
        } else if (response.result === 1) {
          this.$createToast({
            txt: '您所在学校没有开通直播权限',
            type: 'error'
          }).show();
        } else if (response.result === 3) {
          this.$createToast({
            txt: '账号未在爱学班班注册',
            type: 'error'
          }).show();
        } else {
          this.$createToast({
            txt: '账号或密码错误',
            type: 'error'
          }).show();
        }
        this.loginTypeCode = true;
      });
    },
    codeLogin() {
      const params = {
        // mobileOrEmail: this.mobile,
        mobile: this.mobile,
        code: this.code
      };
      api.codeLogin(params).then(response => {
        // if (response.code === 0) {
        if (response.result !== 2 && response.result !== 3 && response.result !== 4) {
          let outTime = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
          // 获取用户信息，设置SET_USER_INFO
          api
            .fetchUserInfo({
              mobile: this.mobile
            })
            .then(response => {
              console.log('获取用户信息：', response);
              // if (response.result.success) { //php后端
              if (response.code === 0) {
                if (response.result.defaultSchoolName !== '') {
                  this.clearForm();
                  !this.isVideo && this.hide();
                  this.isVideo && this.getSchoolIp(response.result.defaultSchoolName, true);
                  window.localStorage['mobile'] = response.result.mobile; // localstorage
                  window.localStorage['outTime'] = outTime;
                  let userInfo = response.result;
                  api
                    .getUserSign({
                      userId: userInfo.uid
                    })
                    .then(resSig => {
                      console.log('res:getUserSign ', resSig);
                      userInfo = { ...userInfo, ...resSig.result };
                      global.localStorage.setItem('userInfo', JSON.stringify(userInfo));
                      // window.localStorage['loginInfo'] = JSON.stringify(loginInfo);
                      if (this.deviceUuid) {
                        // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
                        this.$store.commit('SET_USER_INFO', userInfo);
                        // 通过录播助手进入的列表页面，登录后刷新页面
                        location.reload();
                      } else {
                        this.$store.commit('SET_VISITOR_INFO', userInfo);
                        global.localStorage.setItem('visitorInfo', JSON.stringify(userInfo));
                        location.reload();
                      }
                    });
                } else {
                  this.$createToast({
                    txt: '请到鸿合云平台完善个人信息',
                    type: 'error'
                  }).show();
                }
              } else {
                this.$createToast({
                  txt: '登录失败',
                  type: 'error'
                }).show();
              }
            });
        } else if (response.result === 1) {
          this.$createToast({
            txt: '您所在学校没有开通直播权限',
            type: 'error'
          }).show();
        } else if (response.result === 2) {
          this.$createToast({
            txt: '验证码错误',
            type: 'error'
          }).show();
        } else if (response.result === 4) {
          console.log('register');
          this.$router.push(`/register?deviceUuid=${this.deviceUuid}&mobile=${this.mobile}`);
          // this.$createToast({
          //   txt: '账号未在爱学班班注册',
          //   type: 'error'
          // }).show();
        } else {
          this.$createToast({
            txt: '账号或密码错误',
            type: 'error'
          }).show();
        }
      });
    },
    clearForm() {
      this.mobile = '';
      this.code = '';
      this.password = '';
    },
    blurHandler() {
      window.scroll(0, 0);
    }
  }
};
</script>

<style lang="less">
.cube-extend-popup {
  .cube-popup-mask {
    position: absolute;
    // z-index: 1001;
    bottom: 0;
    background-color: #fff;
    opacity: 1;
  }

  .cube-popup-content {
    background-color: #fff;
  }

  .content {
    position: relative;
    height: 667px;
    margin: 30px 20px 0;

    .svg-icon {
      position: absolute;
      right: 0;
    }

    h1 {
      position: absolute;
      top: 80px;
      font-size: 18px;
    }

    .form {
      position: absolute;
      top: 120px;
      padding: 0;
      width: 100%;

      .m-input {
        margin: 0 10px 10px;

        input {
          text-align: left !important;
        }

        .icon {
          width: 16px;
          height: 16px;
        }

        span {
          color: #2799fc;
          font-size: 12px;
        }
      }

      .cube-input::after {
        border: 0;
        border-bottom: 1px solid #ebebeb;
      }

      p {
        font-size: 12px;
        color: #999;
        text-align: left;
        line-height: 30px;
        margin: 0 10px 10px;

        &.tips {
          line-height: 20px;
          color: #bbb;
          padding-top: 10px;
        }
      }

      .cube-btn {
        border-radius: 25px;
      }
    }
  }
}
.animated {
  animation-duration: 0.5s;
}
</style>
